<template>
    <div class="designeroption" :data-designer-component-id="component_id" v-show="panel_required">
        <h3>{{ title }}</h3>
        <div :class="['stylesoption designer-question-tiled-layout', range_question_columns]">
            <div v-for="range in ranges" @click.prevent="switch_range(range.id)" :class="['tile', localTarget == range.id ? 'active' : '']">
                <a href="#!">
                    <h5 class="mt-0" v-show="show_range_names">{{ range.name }}</h5>
                    <img :src="thumbURL + 'doortype-' + range.thumbnail + '.jpg'" alt="">
                    <label>{{ range.description }}</label>
                    <i class="fa fa-check" aria-hidden="true"></i>
                </a>
            </div>
            <div class="tile" v-for="banner in designer_range_section_banners">
                <a :href="banner.link" target="_blank">
                    <img :src="banner.url" class="full-width">
                </a>
            </div>
            <!--flexbox hack-->
            <div class="tile-empty"></div><div class="tile-empty"></div><div class="tile-empty"></div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Door Range';
                }
            },
            component_id: {
                default(){
                    return 'door_range';
                }
            },
            reference_on: {
                default() {
                    return true;
                },
            },
            ranges: {
                required: true,
            },
            defaults: {
              required: true,
            },
            designer_range_section_banners: {
              default() {
                return [];
              },
            },
            show_range_names: {
              default() {
                return true;
              },
            },
        },
        data() {
          return {
            defaultdoor: this.defaults,
          }
        },
        methods: {
            switch_range(range) {
                window.Swal.fire({
                    title: 'Change Door Range?',
                    text: 'Changing your door range selection will reset your door settings.',
                    type: 'warning',
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Proceed',
                    cancelButtonText: 'Cancel and return',
                }).then((response) => {
                    if(response.isConfirmed){
                        window.emitter.emit('new-door', this.defaultdoor[range], this.reference_on);
                        window.emitter.emit('range-updated');
                    }
                });
            },
        },
        computed: {
            thumbURL(){
                return '/images/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/door-range';
            },
            cache_key(){
                return '_';
            },
            range_question_columns(){
                if(this.ranges.length === 2 || this.ranges.length === 4) {
                    return '_2-col';
                }

                return '_3-col'
            },
            panel_required() {
                return this.ranges.length > 1;
            },
        },
    }
</script>
